// components/common/Breadcrumbs.jsx
import React from "react";
import { FiChevronRight, FiHome } from "react-icons/fi";
import "./Breadcrumbs.css";

function Breadcrumbs({ crumbs, onCrumbClick }) {
  if (!crumbs || crumbs.length <= 0) return null;

  return (
    <nav className="breadcrumbs" aria-label="Breadcrumb">
      {crumbs.map((c, idx) => {
        const isLast = idx === crumbs.length - 1;
        const isRoot = c.path === "root";

        return (
          <span key={`${c.path}-${idx}`} className={`crumb ${isLast ? "current" : ""}`}>
            {/* If it's not the last one, it's a clickable button */}
            {!isLast ? (
              <button
                type="button"
                className="crumb-link"
                onClick={() => onCrumbClick(idx, c)}
                title={c.label}
              >
                {isRoot ? <FiHome className="crumb-icon" /> : <span className="crumb-text">{c.label}</span>}
              </button>
            ) : (
              // Last item is static text (current page)
              <span className="crumb-current" aria-current="page">
                {isRoot ? <FiHome className="crumb-icon" /> : <span className="crumb-text">{c.label}</span>}
              </span>
            )}

            {/* Separator if not last */}
            {!isLast && <FiChevronRight className="crumb-sep-icon" />}
          </span>
        );
      })}
    </nav>
  );
}

export default Breadcrumbs;
